import React from 'react';

function AuthPageShell({ eyebrow, title, footer, children }) {
  return (
    <section className="min-h-screen bg-slate-100">
      <div className="flex min-h-full flex-1 flex-col justify-center pb-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          {eyebrow && <p className="text-center text-xs font-mono text-slate-400 mb-1">{eyebrow}</p>}
          <h2 className="text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 font-oswald">
            {title}
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-white px-6 py-8 shadow sm:rounded-lg sm:px-12">{children}</div>
          {footer}
        </div>
      </div>
    </section>
  );
}

export default AuthPageShell;
